<template>
  <button
    :id="id"
    class="ah-link-button"
    :class="computedClasses"
    :type="type"
    :data-tracking="tracking"
    v-bind="$attrs"
    @click="handleClick"
  >
    <slot />
  </button>
</template>
<script>
  export default {
    name: 'AhButton',
    props: {
      type: {
        type: String,
        default: 'button',
        validator: (value) => ['button', 'submit', 'reset'].includes(value),
      },
      url: {
        type: [String, Object],
        default: null,
      },
      tracking: {
        type: String,
        default: ''
      },
      classes: {
        type: String,
        default: ''
      },
      active: {
        type: Boolean,
        default: false,
      },
      id: {
        type:String,
        default: null
      },
    },
    computed: {
      computedClasses () {
        if (this.active) {
          return [this.classes, 'ah-link-button--active'];
        }
        return this.classes;
      }
    },
    methods: {
      handleClick () {
        this.$emit('ah-button-clicked');
      }
    }
  };
</script>
